/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import {
  Descriptions,
  Card,
} from 'antd';
import ReactJson from 'react-json-view';

const TimelimeDetailsForModal = ({ selectedRecord }) => {
  const data = { ...selectedRecord };
  return (
    <div>
      {selectedRecord && data && Object.keys(data).length > 0
        && (
          <>
            <Card>
              <div>
                ServerName:
                {data.server_name}
              </div>
              <br />
              <div>
                {' '}
                Kitegateway Ref:
                {`${data.kitegateway_reference}`}
              </div>
              <br />
              <div>
                Stage:
                {`${data.stage}`}
              </div>
              <br />
              <div>
                Status:
                {`${data.status}`}
              </div>
              <br />
              <div>
                Message:
                {`${data.status_message}`}
              </div>
              <br />
              <div>
                Callback URL:
                {`${data.callback_url}`}
              </div>
              <br />
              <div>
                Callback Payload:
                {' '}
                <ReactJson src={data.callback_payload} collapsed />
              </div>
              <br />
              <div>
                Callback Response Code:
                {`${data.callback_response_code}`}
              </div>
            </Card>
            <div className="justify-content-center">
              <Card>
                <Descriptions layout="vertical">
                  <Descriptions.Item label="More Details">
                    <ReactJson src={data} collapsed />
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </div>
          </>
        )}
    </div>
  );
};

TimelimeDetailsForModal.propTypes = {
  selectedRecord: PropTypes.oneOfType([
    PropTypes.object,
  ]),
};

TimelimeDetailsForModal.defaultProps = {
  selectedRecord: null,
};
export default TimelimeDetailsForModal;
